import angular from 'angular'
import moment from 'moment-timezone'

angular.module('pub.reviews', []).controller('ReviewsCtrl', ReviewsCtrl)

/** @ngInject */
function ReviewsCtrl(
  $state,
  $scope,
  $stateParams,
  $timeout,
  SetsService,
  CollectiblesService,
  BundleService,
) {
  var vm = this
  vm.set = {}
  vm.collectibles = []
  vm.bundles = []
  vm.isOdd = false
  vm.todo = {
    set: 0,
    setWidth: 0,
    collectible: 0,
    collectibleWidth: 0,
    bundle: 0,
    bundleWidth: 0,
  }

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  SetsService.getId($stateParams.parentId).then(function (result) {
    vm.set = result.results
    if (vm.set['k-prod'] === 3) {
      $('.breadprogress-pagination p')[1].textContent = 'Figure'
    } else if (vm.set['k-prod'] === 2) {
      $('.breadprogress-pagination p')[1].textContent = 'Card'
    } else if (vm.set['k-prod'] === 1) {
      $('.breadprogress-pagination p')[1].textContent = 'Sticker'
    }
    $('#breadcrumb a').last().after(vm.set.t)
  })

  vm.classDisabled = function () {
    if (vm.set.st === 4) {
      return
    }
    if (vm.todo.setWidth === 100 && vm.todo.collectibleWidth === 100) {
      return
    }
    return 'is-disabled'
  }

  SetsService.get($stateParams.parentId).then(function (result) {
    vm.set.id = result.results.id
    vm.set.t = result.results.t
    vm.set.txt = result.results.txt
    vm.set.cid = result.results.cid
    vm.set.st = result.results.st
    if (vm.set.t !== '') {
      vm.todo.set += 1
      vm.todo.setWidth += 20
    }
    if (vm.set.txt !== '') {
      vm.todo.set += 1
      vm.todo.setWidth += 20
    }
    if (result.results.tags !== undefined) {
      vm.todo.set += 1
      vm.todo.setWidth += 20
    }
    if (result.results['img-h'] !== '') {
      vm.todo.set += 1
      vm.todo.setWidth += 20
    }
    if (result.results['img-t'] !== '') {
      vm.todo.set += 1
      vm.todo.setWidth += 20
    }

    vm.todo.setWidth = window.Math.round(vm.todo.setWidth)
    vm.classDisabled()
  })

  CollectiblesService.getSetId($stateParams.parentId).then(function (result) {
    var collectibles = result.results
    for (var i = 0; i < collectibles.length; i++) {
      var count = 0
      if (collectibles[i].t !== '') {
        count += 1
      }
      if (collectibles[i].txt !== '') {
        count += 1
      }
      if (collectibles[i].e !== 0) {
        count += 1
      }
      if (collectibles[i].bc !== 0) {
        count += 1
      }
      if (collectibles[i]['img-t'] !== '') {
        count += 1
      }
      if (count === 5) {
        vm.todo.collectible += 1
      }
    }
    vm.collectibles = collectibles
    vm.todo.collectibleWidth = window.Math.round((vm.todo.collectible / vm.collectibles.length) * 100)
    vm.classDisabled()
  })

  BundleService.get($stateParams.parentId).then(function (result) {
    var bundles = result.results
    for (var i = 0; i < bundles.length; i++) {
      var count = 0
      if (bundles[i].t !== '') {
        count += 1
      }
      // if (bundles[i].txt !== '') {
      //   count += 1;
      // }
      // if (bundles[i].cd !== 0) {
      //   count += 1;
      // }
      // if (bundles[i]['img-l'] !== '') {
      //   count += 1;
      // }
      // if (bundles[i]['img-t'] !== '') {
      //   count += 1;
      // }
      if (count === 1) {
        vm.todo.bundle += 1
      }
    }
    vm.bundles = bundles
    vm.todo.bundleWidth = window.Math.round((vm.todo.bundle / vm.bundles.length) * 100)
    vm.classDisabled()
  })

  var watch1 = $scope.$watch('vm.date', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null) {
      return
    }

    if (newVal) {
      vm.timezoneDate1NY = moment(newVal).tz('America/New_York').format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate1LA = moment(newVal).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm A')
    }
  })

  $scope.$on('$destroy', function () {
    watch1()
  })

  vm.release = function () {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          $('#myModal').modal('hide')
          $('#myModal').on('hidden.bs.modal', function () {
            var channelId = localStorage.getItem('channelId')
            var date
            if (vm.date !== undefined && vm.date !== '' && vm.date !== null) {
              if (isDate(vm.date)) {
                parseInt(new Date(new Date(vm.date).setSeconds(0)).getTime() * 1000)
              } else {
                swal('Date field invalid.', '', 'error')
                return
              }
            } else {
              swal('Required date field.', '', 'error')
              return
            }
            SetsService.update(vm.set.cid, vm.set.id, { 'ts-p': date }).then(function () {
              SetsService.publish(vm.set.id).then(
                function () {
                  toastr.success('Published with success!')
                  $timeout(function () {
                    $state.go('pub.channels.sets', { parentId: channelId })
                  }, 100)
                },
                function (err) {
                  var e = err.error.message.split(';')
                  var html = ''
                  for (var i = 0; i < e.length; i++) {
                    html +=
                      '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
                  }
                  swal({
                    title: 'Sets Incomplete',
                    text: html,
                    html: true,
                  })
                },
              )
            })
          })
        } else {
          return
        }
      },
    )
  }
}
